import React from 'react';

import useHasAccess, { AccessRequirement } from '@/modules/core/hooks/useHasAccess';
import { useAuthStore } from '@/modules/user/stores';

interface Props {
  children: React.ReactNode;
  accessRequirements?: AccessRequirement[];
  accessDeniedAction?: () => void;
}

const Access: React.FC<Props> = ({ children, accessRequirements, accessDeniedAction }) => {
  const { user } = useAuthStore();
  const hasAccess = useHasAccess(accessRequirements);

  if (hasAccess) {
    return <>{children}</>;
  }

  if (accessDeniedAction && user?.permissions?.length) {
    accessDeniedAction();
  }

  return null;
};

export default Access;
